import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { invokePostService, setReRender, handleSnackBar, setCurrentViewId, toggleRightDrawer, setFocusElement } from "../../../store/global/actions";
import JsonTableEditor from "../../atoms/jsonFormEditor/JsonTableEditor";
import UpdateCancel from "../../atoms/buttons/UpdateCancel";
import { Grid } from '@material-ui/core';
import { viewFormSchema, viewFormSectionSchema, getViewSchemaData, customiseViewForm, generateViewSchema, viewFormValidation } from '../../../services/entities/DashboardBuilder.js';
import { IconSelector } from '../../atoms/IconSelectorV2';
import { useHistory } from "react-router-dom";
import { getDetailsFromUrl } from '../../../services/blueprint';
import { findIconSource, generateIconFileName, formatFetchedCustomIcons } from "../../../utils/commonUtils";
import { editView } from "../../../store/views/actions";
import './style.css';

const options = {
    form_name_root: "view_form",
    show_errors: "interaction",
    disable_array_add: false,
    disable_array_reorder: true,
    disable_properties: false,
    no_additional_properties: false,
    keep_oneof_values: false,
    disable_array_delete_all_rows: true,
    disable_array_delete_last_row: true,
}

export default function ViewForm({ action, onClose, selectedView }) {
    const dispatch = useDispatch();
    const history = useHistory();

    const { slug, blueprintId } = getDetailsFromUrl();

    const [schemaValues, setSchemaValues] = useState({});
    const [viewSchema, setViewSchema] = useState({});
    const [loading, setLoading] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);
    const [ formData, setFormData] = useState({});
    const [noIcon, setNoIcon] = useState('');
    const [icon, setIcon] = useState(selectedView?.icon ? formatFetchedCustomIcons(selectedView) : null);
    const [editorObj, setEditorObj] = useState(null);

    useEffect(() => {
        if(icon){
            console.log("--icon selected--")
            setNoIcon("")
        }
    }, [icon])

    useEffect(() => {
        setLoading(true);
        let schema = viewFormSchema;
        let schemaData = getViewSchemaData(selectedView);
        if (action === "create") {
            schema = { ...schema, properties: { ...schema.properties, ...viewFormSectionSchema } };
        }
        setViewSchema(schema);
        setSchemaValues(schemaData);
        setLoading(false);
    }, [])


    const onChangeJsonEditor = (data, jsonEditor) => {
        setEditorObj(jsonEditor);
        setFormData(data);
        customiseViewForm(data);
        const validationErrors = jsonEditor.validate();

        const input = document.querySelector('input[name="view_form[instance_prompt]"]');

        const helperText = document.getElementById('view_form[instance_prompt]-description')

        if (!input || !helperText) {
            console.warn('Could not find input or helper text element');
            return;
        }

        const value = input.value.trim() || 'view instance';

        helperText.textContent = `Prompt shown to users : "Enter ${value}"`;
        input.removeEventListener('input', updateHelperText); // Safe if not yet added
        function updateHelperText() {
            const updatedValue = input.value.trim() || 'view instance';
            helperText.textContent = `Prompt shown to users : "Enter ${updatedValue}"`;
        }

        input.addEventListener('input', updateHelperText);
    }


    const onSubmit = () => {
        const validationErrors = editorObj.validate();
        if (validationErrors.length > 0 || icon == null) {
            editorObj.showValidationErrors(validationErrors);
            if (icon == null) {
                setNoIcon('Please select an icon')
            } else {
                setNoIcon("");
            }
            return;
        }

        setIsUpdating(true);
        if (action === "create") {
            const view = generateViewSchema({ ...formData, icon });
            dispatch(invokePostService('createView', { view }, [])).then(response => {
                if (response.status) {
                    dispatch(setCurrentViewId(response.response._id));
                    history.push(`/blueprint/${slug}/${blueprintId}/view/${response.response._id}`);
                    onClose();
                    dispatch(setReRender());
                    dispatch(handleSnackBar({ open: true, message: "View created successfully", severity: 'success' }));
                } else {
                    if (response?.code === process.env.REACT_APP_FORM_ERROR_CODE) {

                    }
                }
                setIsUpdating(false);
            });
        }

        if (action === "edit") {
            const updatedView = {
                ...selectedView,
                ...formData,
                view_schema: selectedView.view_schema,
            }

            if (icon) {
                updatedView.icon = generateIconFileName(icon);
                updatedView.iconSource = findIconSource(icon);
            }

            dispatch(invokePostService('updateView', { view: updatedView }, [updatedView._id])).then(response => {
                if (response.status === true) {
                    dispatch(editView(updatedView));
                    dispatch(handleSnackBar({ open: true, message: `View updated`, severity: "success" }));
                    dispatch(setFocusElement({ id: updatedView._id, type: "view", action: "edit", name: updatedView.name }))
                } else {
                    dispatch(editView(selectedView));
                    if (response?.code === process.env.REACT_APP_FORM_ERROR_CODE) {
                        dispatch(handleSnackBar({ open: true, message: response.errors[0].message, severity: 'error' }))
                    }
                    if (response.code === 255) {
                        history.push(`/blueprint/${slug}/${blueprintId}/system-model`);
                        dispatch(setReRender());
                        dispatch(setFocusElement({}))
                        // if (rightDrawerStatus == true) dispatch(toggleRightDrawer());
                    }
                }
                setIsUpdating(false);
            });
        }
    }

    return (
        <>
            {!loading && Object.keys(viewSchema).length > 0 &&
                <JsonTableEditor options={options} schema={viewSchema} schemaValues={schemaValues} validation={viewFormValidation} onChangeJsonEditor={onChangeJsonEditor} editorId={"view_form"} />
            }
            <IconSelector setSelectedIcon={setIcon} selectedIcon={icon} entityType={'view'} defaultSearchTag={formData.name} />
            {noIcon !== '' && <Grid item xs={12} style={{ color: 'red' }}>
                <p id={"no-icon-alert"} className={"invalid-feedback"} style={{font: "inherit", fontFamily: "Roboto, Helvatica", display:"block"}}>{noIcon}</p>
            </Grid>}
            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }}>
                <UpdateCancel updateDisable={isUpdating || loading} content={isUpdating ? (action === "create" ? "Creating.." : "Updating..") : (action === "create" ? "Create" : "Update")} onUpdate={onSubmit} onCancel={onClose} />
            </Grid>
        </>
    )



}